import { WALLET_MODAL } from '../global-constants.js';
import { setDealerDRLeaseEnabled } from '../helpers/index.js';

// Insert the My Wallet Modal
export const insertWalletModal = async (API, walletScriptHost, config, vehicles, hasLeasing = false) => {
	// Get the site's My Wallet integration configuration
	const { enableLeasePayments, walletTheme } = config;
	const enablePaymentOption = vehicles?.length > 0 && enableLeasePayments && hasLeasing;

	API.insert('page-footer', async (elem) => {
		const walletModal = document.createElement(WALLET_MODAL);

		// Apply styles here to ensure correct stacking
		walletModal.style.position = 'relative';
		// DDC Sticky Header is 1030
		walletModal.style.zIndex = '1031';
		// Required for Safari
		walletModal.style.display = 'block';


		// to enable payment options buttons on wallet modal
		if (enablePaymentOption) {
			// write to local storage and access it while building payment request in carApi.js
			setDealerDRLeaseEnabled(true);
		} else {
			// set false when enableLeasePayments is turned off or DR admin config is updated
			setDealerDRLeaseEnabled(false);
		}

		API.append(elem, walletModal);

		// Attributes must be set after the element is connected to the DOM, otherwise
		// the web component's constructor/MutationObserver misses them and props stay undefined.
		if (walletTheme) {
			walletModal.setAttribute('theme', walletTheme);
		}
		if (enablePaymentOption) {
			walletModal.setAttribute('data-feature-flags', '{"wallet_payment_option": { "enabled": true }}');
		}

		await API.loadJS(`${walletScriptHost}/${WALLET_MODAL}.js`);
	});
}
